// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("@rails/activestorage").start();
require("turbolinks").start();
require("channels");
require("jquery");
window.$ = $;
window.jQuery = $;

import "./company/common.js";
import "./functions.js";
import "./_add/exif.js";
import "./vue.js";
import "../company/form.js";
import "../company/ui.js";

//オートコンプリートに使用
import "./_add/jquery-ui.min.js";
import ClipboardJS from "./_add/clipboard.min.js";
window.ClipboardJS = ClipboardJS;
import EXIF from "./_add/exif.js";
window.EXIF = EXIF;
import "@/animation";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
